<template>
  <div>
    <GmapMap style="width: 100%; height: 240px;" :zoom="11" :center="center">
      <GmapCluster>
        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
          {{infoContent}}
        </gmap-info-window>
        <GmapMarker v-for="(marker, index) in markers":key="index":position="marker.position" :clickable="true" @click="toggleInfoWindow(marker,index)" :draggable="true"/>
        <GmapMarker v-if="this.place" label="★" :position="{lat: this.place.geometry.location.lat(),lng: this.place.geometry.location.lng(),}" />
      </GmapCluster>
    </GmapMap>
  </div>
</template>
<script>
export default {
  name: 'kundekort',
  data () {
    return {
      markers: [],
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      infoWinOpen: false,
      place: null,
      center: {
        lat: 55.6680529,
        lng: 12.5417883
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      }
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    var data = {operation: 'openjob_partner_map', salesPerson: this.salesPerson}
    this.$http.post('', data, { emulateJSON: true })
      .then(
        response => {
          var res = response.body
          if (res.login === false) {
            this.$router.push('/login')
          }
          this.center = res.location
          this.markers = res.geocodes
        },
        response => {
          alert('error')
        }
      )
  },
  description: '',
  methods: {
    setDescription (description) {
      this.description = description
    },
    setPlace (place) {
      this.place = place
    },
    usePlace (place) {
      if (this.place) {
        this.markers.push({
          position: {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng()
          }
        })
        this.place = null
      }
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = marker.infoText
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// KundeMap.vue?37e46f6f